import { InputElementBase, InputElementBaseProperties } from '@episerver/forms-sdk';
import { useCallback, useState } from 'react';
import { GoogleReCaptchaProvider, GoogleReCaptcha} from 'react-google-recaptcha-v3';
import { DispatchFunctions } from "3-components/OptimizelyForm/context/dispatchFunctions";

interface RecaptchaV3ElementProps extends InputElementBaseProperties {
    recaptchaSiteKey: string
}
interface RecaptchaV3Element extends InputElementBase {
    properties: RecaptchaV3ElementProps;
}

export interface RecaptchaV3ElementBlockProps {
    element: RecaptchaV3Element
}

export const RecaptchaV3ElementBlock = (props: RecaptchaV3ElementBlockProps) => {
    const { element } = props;
    const [token, setToken] = useState();
    const dispatchFuncs = new DispatchFunctions();
    // const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

    const onVerify = useCallback((token: any) => {
        setToken(token);
        dispatchFuncs.updateValue(element.key, token);
      }, []);

    if(!element.properties.recaptchaSiteKey) {
        return (
            <div className="Form__Status">
                <div role="alert" aria-live="polite" className="Form__Status__Message Form____Message" data-f-form-statusmessage="">
                    <p>Please set Recaptcha key.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="Form__Element RecaptchaV3Element">
            <GoogleReCaptchaProvider reCaptchaKey={element.properties.recaptchaSiteKey}>
                <GoogleReCaptcha onVerify={onVerify} />
                <input className="FormHidden" type="hidden" name={element.key} id={element.key} value={token} />
            </GoogleReCaptchaProvider>
        </div>
    )
}